module.exports = __webpack_public_path__ + "static/media/givingPrize1.ed7e9164.jpeg";